module.exports = __webpack_public_path__ + "img/sliders-06.48928c7c.jpg";